export const defaultConfig = {
    url: process.env.REACT_APP_CHAT_URL,
    widgetTitle: "Amix responde",
    primaryColor: process.env.REACT_APP_PRIMARY_COLOR,
    secondaryColor: process.env.REACT_APP_SECONDARY_COLOR,
    position: process.env.REACT_APP_POSITION,
    welcomeMessage: "¡Hola soy Amix, y te ayudaré a resolver tus dudas!",
    placeholderText: "Preguntame algo...",
    offlineMessage: "Lo siento, el servicio no está disponible en este momento.",
    maxMessages: parseInt(process.env.REACT_APP_MAX_MESSAGES),
    typingDelay: parseInt(process.env.REACT_APP_TYPING_DELAY),
    apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT),
};
// 